import React from "react";
import { RequestDetailsTable, RequestPhotoAutoInfo } from "../components";
import RequestDocumentsInfo from "../components/RequestDetailsComponent/components/RequestDocumentsInfo";
import ChangeHistory from "../components/RequestDetailsComponent/components/ChangeHistory";
import CreditHistory from "../components/RequestDetailsComponent/components/CreditHistory";
import {PhotoTypes, requestClientData, requestCreditHistory, requestsData} from "../constants/constants";

const ClientInfoTab = ({
  details,
  showCommentFields,
  comments,
  changes,
  handleCommentChange,
  handleUpdateDetails,
}) => {
  const clientDetails = {
    ...details.client_info,
    ...details.credit_report_calculation,
    ...(details.documents.some(doc => doc.documentType === 'INCOME_VERIFICATION') && {
      incomeVerificationDocument: changes?.incomeVerificationDocument || false,
    }),
  };

  return (
    <RequestDetailsTable
      details={clientDetails}
      requestFields={requestClientData}
      showCommentFields={showCommentFields}
      comments={comments}
      handleCommentChange={handleCommentChange}
      onUpdateDetails={handleUpdateDetails}
    />
  );
};

export const tabsItems = [
  {
    key: "1",
    label: "Общая информация",
    isDisplayStatusBadge: true,
    isDisplayEditButton: true,
    component: ({
      details,
      showCommentFields,
      comments,
      status,
      isEditing,
      handleCommentChange,
      handleUpdateDetails,
    }) => (
      <RequestDetailsTable
        details={details?.car_request}
        requestFields={requestsData}
        status={status}
        showCommentFields={showCommentFields}
        comments={comments}
        isEditing={isEditing}
        handleCommentChange={handleCommentChange}
        onUpdateDetails={handleUpdateDetails}
      />
    ),
  },
  {
    key: "2",
    label: "Клиент",
    isDisplayStatusBadge: true,
    component: ClientInfoTab
  },
  {
    key: "3",
    label: "Фото ТС",
    isDisplayStatusBadge: true,
    component: (props) => <RequestPhotoAutoInfo photoType={PhotoTypes.AUTO} name='vehiclePhotos' {...props} />,
  },
  {
    key: "4",
    label: "Фото ПТС",
    isDisplayStatusBadge: true,
    component: (props) => (
      <RequestPhotoAutoInfo photoType={PhotoTypes.DOCUMENT} name='registrationDocumentPhotos' {...props}/>
    ),
  },
  {
    key: "5",
    label: "Документы",
    component: (props) => <RequestDocumentsInfo {...props} />,
  },
  {
    key: "6",
    label: "История изменений",
    isDisplayStatusBadge: true,
    component: () => (<ChangeHistory />)
  },
  {
    key: "7",
    label: "Кредитная история",
    isDisplayStatusBadge: false,
    component: (props) => (<CreditHistory data={requestCreditHistory} {...props}  />)
  },
];